import { useEffect, useRef, useState } from 'react';
import { isEqual } from 'lodash';

const DEFAULT_DEBOUNCE_TIMER = 250;

const useDebounce = <T>(value: T, delay: number = DEFAULT_DEBOUNCE_TIMER): T => {
    const [debouncedValue, setDebouncedValue] = useState(value);
    const prevValueRef = useRef(value);

    useEffect(() => {
        const handler = setTimeout(() => {
            if (!isEqual(prevValueRef.current, value)) {
                setDebouncedValue(value);
            }
            prevValueRef.current = value;
        }, delay);

        return () => {
            clearTimeout(handler);
        };
    }, [value, delay]);

    return debouncedValue;
};

export default useDebounce;
